/*
  Bolinhas da galeria do produto no mobile: uma por foto, a ativa acompanha o swipe do slider.
  O slider continua sendo o nativo do Dawn (scroll-snap); este script só desenha e atualiza os pontos.
*/
(function () {
  function init(dots) {
    const list = dots.parentElement.querySelector('.product__media-list');
    if (!list) return;

    let slides = [];
    let items = [];

    function build() {
      slides = Array.from(list.querySelectorAll('.slider__slide'));
      dots.textContent = '';
      items = slides.map(function () {
        const dot = document.createElement('span');
        dot.className = 'product-gallery-dots__dot';
        dots.appendChild(dot);
        return dot;
      });
      update();
    }

    function update() {
      if (!slides.length) return;
      const listLeft = list.getBoundingClientRect().left;
      let active = 0;
      let best = Infinity;
      slides.forEach(function (slide, index) {
        const distance = Math.abs(slide.getBoundingClientRect().left - listLeft);
        if (distance < best) {
          best = distance;
          active = index;
        }
      });
      items.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === active);
      });
    }

    list.addEventListener('scroll', update, { passive: true });
    build();
  }

  function ready() {
    document.querySelectorAll('[data-gallery-dots]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
